import { Model } from '@vuex-orm/core'

export default class LicensePlanMaster extends Model {
  static entity = 'licensePlanMasters'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      allowProjects: this.boolean(false),
      contractType: this.string(''),
      maxCafeCapacity: this.number(0),
      maxGroups: this.number(0),
      maxFileSize: this.number(0), // MB
      maxStoreDuration: this.number(0), // Month
      maxUsers: this.number(0),
      planName: this.string(''),
      planDescription: this.string(''),
      price: this.number(0)
    }
  }
}
